(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["epic-aurora-preview"] && !Shopify.designMode) return;
  try {
    
function placeAuroraFilms(root = document) {
  root.querySelectorAll('.epic-aurora').forEach(section => {
    if (section.dataset.filmPlaced) return;
    const film = section.querySelector('.epic-aurora__film');
    const stage = section.querySelector('.epic-aurora__art-stage');
    const story = section.querySelector('.epic-aurora__story');
    const heading = story?.querySelector('h3');
    if (!film || !stage || !heading) return;
    section.dataset.filmPlaced = 'true';
    const mobile = window.matchMedia('(max-width: 749px)');
    const place = () => {
      if (mobile.matches) stage.append(film);
      else story.insertBefore(film, heading);
      const video = film.querySelector('video');
      if (video?.autoplay) video.play().catch(() => {});
    };
    mobile.addEventListener('change', place);
    place();
  });
}
placeAuroraFilms();
document.addEventListener('shopify:section:load', event => placeAuroraFilms(event.target));
function initAuroraCountdowns(root = document) {
  root.querySelectorAll('[data-aurora-countdown]').forEach(countdown => {
    if (countdown.dataset.initialized) return;
    countdown.dataset.initialized = 'true';
    const target = Date.parse(countdown.dataset.target);
    const timer = countdown.querySelector('.epic-aurora__timer');
    const launched = countdown.querySelector('.epic-aurora__launched');
    let interval;
    const update = () => {
      if (!countdown.isConnected) { clearInterval(interval); return; }
      const remaining = Math.max(0, Math.ceil((target - Date.now()) / 1000));
      const values = { days: Math.floor(remaining / 86400), hours: Math.floor(remaining / 3600) % 24, minutes: Math.floor(remaining / 60) % 60, seconds: remaining % 60 };
      Object.entries(values).forEach(([unit, value]) => {
        const el = countdown.querySelector('[data-aurora-unit="' + unit + '"]');
        const text = String(value).padStart(2, '0');
        if (el.textContent !== text) el.textContent = text;
      });
      timer.hidden = remaining === 0;
      launched.hidden = remaining > 0;
      if (remaining === 0) clearInterval(interval);
    };
    update();
    if (Date.now() < target) interval = setInterval(update, 1000);
  });
}
initAuroraCountdowns();
document.addEventListener('shopify:section:load', event => initAuroraCountdowns(event.target));

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["epic-gift-card-product"] && !Shopify.designMode) return;
  try {
    
  class EpicGiftCard {
    constructor(root) {
      this.root = root;
      this.amount = root.querySelector('[data-amount-input]');
      this.select = root.querySelector('[data-variant-select]');
      this.variantId = root.querySelector('[data-variant-id]');
      this.previewAmount = root.querySelector('[data-preview-amount]');
      this.buttonAmount = root.querySelector('[data-button-amount]');
      this.preview = root.querySelector('[data-preview-card]');
      this.uploadArea = root.querySelector('[data-upload-area]');
      this.photoInput = root.querySelector('[data-photo-input]');
      this.photoWrap = root.querySelector('[data-photo-wrap]');
      this.photoPreview = root.querySelector('[data-photo-preview]');
      this.drawingToggle = root.querySelector('[data-drawing-toggle]');
      this.drawingTools = root.querySelector('[data-drawing-tools]');
      this.drawingCanvas = root.querySelector('[data-drawing-canvas]');
      this.drawingFile = root.querySelector('[data-drawing-file]');
      this.drawingContext = this.drawingCanvas.getContext('2d');
      this.drawingColor = '#f7efe7';
      this.drawingStrokes = [];
      this.activeStroke = null;
      this.recipientFields = root.querySelector('[data-recipient-fields]');
      this.recipientInputs = [...root.querySelectorAll('[data-recipient-field]')];
      this.message = root.querySelector('[data-message]');
      this.name = root.querySelector('[data-recipient-name]');
      this.email = root.querySelector('[data-recipient-email]');
      this.sendOn = root.querySelector('[data-send-on]');
      this.offset = root.querySelector('[data-offset]');
      this.init();
    }

    init() {
      this.root.querySelector('[data-amount-down]').addEventListener('click', () => this.changeAmount(-5));
      this.root.querySelector('[data-amount-up]').addEventListener('click', () => this.changeAmount(5));
      this.amount.addEventListener('change', () => this.setAmount(this.amount.value));
      this.amount.addEventListener('blur', () => this.setAmount(this.amount.value));
      this.root.querySelectorAll('[data-design-option]').forEach((input) => input.addEventListener('change', () => this.setDesign(input.dataset.designOption)));
      this.root.querySelector('[data-preview-jump]').addEventListener('click', () => {
        const anchor = this.root.querySelector('[data-preview-anchor]');
        anchor.scrollIntoView({ block: 'start', behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth' });
        anchor.focus({ preventScroll: true });
      });
      this.root.querySelectorAll('[data-delivery-choice]').forEach((input) => input.addEventListener('change', () => this.setDelivery(input.value)));
      this.photoInput.addEventListener('change', () => this.setPhoto());
      this.drawingToggle.addEventListener('change', () => this.setDrawing(this.drawingToggle.checked));
      this.root.querySelectorAll('[data-drawing-color]').forEach((button) => button.addEventListener('click', () => {
        this.drawingColor = button.dataset.drawingColor;
        this.root.querySelectorAll('[data-drawing-color]').forEach((item) => item.classList.toggle('is-active', item === button));
      }));
      this.root.querySelector('[data-drawing-undo]').addEventListener('click', () => this.undoDrawing());
      this.root.querySelector('[data-drawing-clear]').addEventListener('click', () => this.clearDrawing());
      this.drawingCanvas.addEventListener('pointerdown', (event) => this.startDrawing(event));
      this.drawingCanvas.addEventListener('pointermove', (event) => this.moveDrawing(event));
      this.drawingCanvas.addEventListener('pointerup', (event) => this.finishDrawing(event));
      this.drawingCanvas.addEventListener('pointercancel', (event) => this.finishDrawing(event));
      window.addEventListener('resize', () => this.resizeDrawingCanvas());
      this.message.addEventListener('input', () => {
        this.root.querySelector('[data-message-count]').textContent = this.message.value.length;
      });
      this.name.addEventListener('input', () => {
        this.root.querySelector('[data-preview-recipient]').textContent = this.name.value || this.root.querySelector('[data-preview-recipient]').dataset.fallback || 'FOR SOMEONE SPECIAL';
      });
      this.offset.value = String(new Date().getTimezoneOffset());
      this.setDateLimits();
      this.setAmount(this.amount.value);
    }

    setAmount(value) {
      const numeric = Math.min(300, Math.max(20, Math.round(Number(value || 20) / 5) * 5));
      const option = [...this.select.options].find((item) => Number(item.dataset.price) === numeric);
      this.amount.value = numeric;
      if (!option) return;
      this.select.value = option.value;
      this.variantId.value = option.value;
      this.previewAmount.textContent = new Intl.NumberFormat(document.documentElement.lang || 'de', { style: 'currency', currency: this.root.dataset.baseCurrency || 'EUR' }).format(numeric);
      this.buttonAmount.textContent = option.textContent;
    }

    changeAmount(delta) { this.setAmount(Number(this.amount.value) + delta); }

    setDesign(design) {
      this.preview.dataset.design = design;
      const own = design === 'own';
      this.uploadArea.hidden = !own;
      this.photoInput.disabled = !own;
      if (!own) this.photoWrap.hidden = true;
    }

    setDelivery(value) {
      const gift = value === 'gift';
      this.recipientFields.hidden = !gift;
      this.recipientInputs.forEach((input) => { input.disabled = !gift; });
      this.email.required = gift;
      if (gift) this.name.focus({ preventScroll: true });
    }

    setPhoto() {
      const file = this.photoInput.files[0];
      const error = this.root.querySelector('[data-file-error]');
      error.hidden = true;
      if (!file) {
        this.photoWrap.hidden = true;
        return;
      }
      if (file.size > 10485760 || !['image/jpeg', 'image/png', 'image/webp'].includes(file.type)) {
        this.photoInput.value = '';
        this.photoWrap.hidden = true;
        error.hidden = false;
        return;
      }
      const reader = new FileReader();
      reader.addEventListener('load', () => {
        this.photoPreview.src = reader.result;
        this.photoWrap.hidden = false;
      });
      reader.readAsDataURL(file);
    }

    setDrawing(enabled) {
      this.drawingCanvas.hidden = !enabled;
      this.drawingTools.hidden = !enabled;
      this.drawingFile.disabled = !enabled;
      if (enabled) {
        this.resizeDrawingCanvas();
        this.redrawCanvas();
      } else {
        this.drawingFile.value = '';
      }
    }

    resizeDrawingCanvas() {
      if (this.drawingCanvas.hidden) return;
      const rect = this.drawingCanvas.getBoundingClientRect();
      const ratio = Math.min(window.devicePixelRatio || 1, 2);
      const width = Math.max(1, Math.round(rect.width * ratio));
      const height = Math.max(1, Math.round(rect.height * ratio));
      if (this.drawingCanvas.width === width && this.drawingCanvas.height === height) return;
      this.drawingCanvas.width = width;
      this.drawingCanvas.height = height;
      this.drawingContext.setTransform(ratio, 0, 0, ratio, 0, 0);
      this.redrawCanvas();
    }

    drawingPoint(event) {
      const rect = this.drawingCanvas.getBoundingClientRect();
      return {
        x: Math.min(1, Math.max(0, (event.clientX - rect.left) / rect.width)),
        y: Math.min(1, Math.max(0, (event.clientY - rect.top) / rect.height))
      };
    }

    startDrawing(event) {
      if (!this.drawingToggle.checked) return;
      event.preventDefault();
      this.drawingCanvas.setPointerCapture(event.pointerId);
      this.activeStroke = { color: this.drawingColor, points: [this.drawingPoint(event)] };
      this.drawingStrokes.push(this.activeStroke);
      this.redrawCanvas();
    }

    moveDrawing(event) {
      if (!this.activeStroke) return;
      event.preventDefault();
      this.activeStroke.points.push(this.drawingPoint(event));
      this.redrawCanvas();
    }

    finishDrawing(event) {
      if (!this.activeStroke) return;
      event.preventDefault();
      this.activeStroke = null;
      this.syncDrawingFile();
    }

    redrawCanvas() {
      const rect = this.drawingCanvas.getBoundingClientRect();
      if (!rect.width || !rect.height) return;
      this.drawingContext.clearRect(0, 0, rect.width, rect.height);
      this.drawingContext.lineCap = 'round';
      this.drawingContext.lineJoin = 'round';
      this.drawingContext.lineWidth = Math.max(3, rect.width * .007);
      this.drawingStrokes.forEach((stroke) => {
        if (!stroke.points.length) return;
        this.drawingContext.beginPath();
        this.drawingContext.strokeStyle = stroke.color;
        stroke.points.forEach((point, index) => {
          const x = point.x * rect.width;
          const y = point.y * rect.height;
          if (index === 0) this.drawingContext.moveTo(x, y);
          else this.drawingContext.lineTo(x, y);
        });
        if (stroke.points.length === 1) {
          const point = stroke.points[0];
          this.drawingContext.lineTo((point.x * rect.width) + .1, point.y * rect.height);
        }
        this.drawingContext.stroke();
      });
    }

    undoDrawing() {
      this.drawingStrokes.pop();
      this.redrawCanvas();
      this.syncDrawingFile();
    }

    clearDrawing() {
      this.drawingStrokes = [];
      this.redrawCanvas();
      this.drawingFile.value = '';
    }

    syncDrawingFile() {
      if (!this.drawingStrokes.length) {
        this.drawingFile.value = '';
        return;
      }
      this.drawingCanvas.toBlob((blob) => {
        if (!blob || typeof DataTransfer === 'undefined') return;
        const transfer = new DataTransfer();
        transfer.items.add(new File([blob], 'epic-e-card-zeichnung.png', { type: 'image/png' }));
        this.drawingFile.files = transfer.files;
      }, 'image/png');
    }

    setDateLimits() {
      const today = new Date();
      const future = new Date(today);
      future.setDate(future.getDate() + 90);
      const format = (date) => date.toISOString().slice(0, 10);
      this.sendOn.min = format(today);
      this.sendOn.max = format(future);
    }
  }

  document.querySelectorAll('[data-epic-card]').forEach((root) => new EpicGiftCard(root));

  } catch(e) { console.error(e); }
})();
})();
